import { render, staticRenderFns } from "./Cleaner.vue?vue&type=template&id=2b94e588&scoped=true&lang=pug"
import script from "./Cleaner.vue?vue&type=script&lang=js"
export * from "./Cleaner.vue?vue&type=script&lang=js"
import style0 from "./Cleaner.vue?vue&type=style&index=0&id=2b94e588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b94e588",
  null
  
)

export default component.exports